import { render } from "./RichCard.vue?vue&type=template&id=44b8345a&scoped=true"
import script from "./RichCard.vue?vue&type=script&lang=js"
export * from "./RichCard.vue?vue&type=script&lang=js"

import "./RichCard.vue?vue&type=style&index=0&id=44b8345a&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b8345a"]])

export default __exports__